// Botão redondo "compartilhar" sobre a foto do topo, o mesmo da página do imóvel
// (pages/imoveis/components/pieces/properties/botoes/Compartilhar.tsx). Sem o coração: favorito é de imóvel.
// O clique fica no <button> (no imóvel está só no ícone e a borda do círculo não responde).
import { FaShareAlt } from 'react-icons/fa';
import styles from './EmpreendimentoDetalhe.module.css';

const CompartilharEmpreendimento = ({ titulo, nome, className }: { titulo: string; nome: string; className: string }) => {
    const compartilhar = async () => {
        const dados = { title: titulo, text: `Conheça ${titulo}`, url: window.location.href };
        if (navigator.share) {
            try {
                await navigator.share(dados);
            } catch {
                // cancelado pelo visitante
            }
            return;
        }
        // Mesmo fallback do imóvel para navegador sem Web Share API.
        alert('Compartilhamento não suportado neste navegador. URL copiada para a área de transferência!');
        navigator.clipboard?.writeText(dados.url);
    };

    return (
        <ul className={className}>
            <li>
                <button
                    type="button"
                    className={styles.balaoRedondo}
                    onClick={compartilhar}
                    aria-label={`Compartilhar ${nome}`}
                    title={`Compartilhar ${nome}`}
                >
                    <FaShareAlt className={styles.balaoRedondoIcone} />
                </button>
            </li>
        </ul>
    );
};

export default CompartilharEmpreendimento;
